export default "<p>menu-sidebar-sale works!</p>\n"